import { Service } from 'typedi';
import axios from 'axios';
import { apiResponse } from './apiResponse';

@Service()
class AuthService {
  async login(emailAddress: string, password: string) {
    const response = await apiResponse(
      axios.post('/api/auth/login', { emailAddress, password }));
  }
  async logout() {
    const response = await apiResponse(
      axios.post('/api/auth/logout')
    );
  }
}

export default AuthService;
